import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePreference } from "../context/UserContext";
import QuizzesModel from "../common/QuizzesModel";
// import "../assets/css/homepage.css";
import { Button, Modal } from "react-bootstrap";
import PayPalModal from "./paypal/PaypalModel";
import SubscribeButton from "./SubscribeButton";
import Swal from "sweetalert2";
import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  Pinterest,
  ArrowLeft,
} from "@mui/icons-material";
import imageUrl from "../assets/img/aaa.png"; // Import the local image
import DescriptionComponent from "./DescriptionComponent";
import SpellingLoader2 from "../common/SpellingLoader2";
import ComingSoon from "../common/ComingSoon";
import ShowCart from "./ShowCart";
import TTSTest from "../common/TTSTest";
import AdvertisementModel from "../common/AdvertisementModel";
import LandingPage from "./login/LandingPage";
// import VenmoCheckout from "./paypal/VenmoCheckout";
import BEE from "../assets/img/placeholderImage3.png";

const SubCategories = () => {
  const location = useLocation();
  const { subcategories = [] } = location.state || {};
  console.log(subcategories);
  const [data, setData] = useState([]);
  const [expandedPacks, setExpandedPacks] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const username = localStorage.getItem("username");
  const userRole = localStorage.getItem("userrole");
  const navigate = useNavigate();
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);
  const togglePackVisibility = (packId) => {
    setExpandedPacks((prev) => ({
      ...prev,
      [packId]: !prev[packId], // Toggle visibility
    }));
  };
  const { updateIsNavVisible, showCart, updateShowCart, cart, updateCart } =
    usePreference();

  const updateQuizId = (value) => {
    navigate(`/playquiz/${value}`);
  };
  const addToCart = (pack, type, price, isCollection, action, packname) => {
    updateShowCart(true);

    // Ensure cart is initialized as an empty array if it's not already
    updateCart((prevCart) => {
      const currentCart = Array.isArray(prevCart) ? prevCart : [];

      if (action === "add") {
        // Check if the item (either collection or category) is already in the cart
        const itemAlreadyInCart = currentCart.some(
          (item) =>
            item.packId === pack.Id && item.isCollection === isCollection
        );

        if (itemAlreadyInCart) {
          Swal.fire({
            title: "Info",
            text: "This item is already in your cart.",
            icon: "info",
          });
          return currentCart; // Stop here if the item is already in the cart
        }

        if (isCollection) {
          if (Array.isArray(pack.Categories)) {
            const categoryAlreadyInCart = currentCart.some((item) =>
              pack.Categories.some(
                (category) => item.packId === category.CollectionId
              )
            );

            if (categoryAlreadyInCart) {
              Swal.fire({
                title: "Alert",
                text: "Some categories from this collection are already in your cart. Please remove them first if you wish to add the entire collection.",
                icon: "warning",
              });
              return currentCart;
            }

            // Remove all categories that are part of this collection
            const updatedCart = currentCart.filter(
              (item) =>
                !pack.Categories.some(
                  (category) => item.packId === category.CollectionId
                )
            );
            const newCartItem = {
              pack,
              packId: pack.Id,
              type,
              price,
              isCollection,
              packname: packname,
            };

            const newCart = [...updatedCart, newCartItem];
            localStorage.setItem("cart", JSON.stringify(newCart)); // Save to localStorage
            return newCart;
          }
        } else {
          if (Array.isArray(currentCart)) {
            const collectionInCart = currentCart.some(
              (item) => item.packId === pack.CollectionId
            );

            if (collectionInCart) {
              Swal.fire({
                title: "Alert",
                text: "The collection containing this category is already in your cart. You cannot add individual categories from the collection.",
                icon: "warning",
              });
              return currentCart;
            }
          }

          const newCartItem = {
            pack,
            packId: pack.Id,
            type,
            price,
            isCollection: false,
            packname: packname,
          };

          const newCart = [...currentCart, newCartItem];
          localStorage.setItem("cart", JSON.stringify(newCart)); // Save to localStorage
          return newCart;
        }
      } else if (action === "remove") {
        const updatedCart = currentCart.filter(
          (item) =>
            !(item.packId === pack.Id && item.isCollection === isCollection)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart)); // Save updated cart to localStorage
        return updatedCart;
      }
    });
  };

  useEffect(() => {
    const targetDate = new Date("2024-12-31");
    const currentDate = new Date();

    // Check if current date is before the target date
    if (currentDate < targetDate) {
      // Check login status using localStorage
      const isLoggedIn = localStorage.getItem("loggedin") === "true"; // Check if logged in

      if (!isLoggedIn) {
        // Non-logged-in users: Show modal only once per day
        // const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format
        // const lastShownDate = localStorage.getItem("modalLastShownDate");

        setIsOpenAdd(true);
      } else {
        // Non-logged-in users: Show modal only once per day
        const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format
        const lastShownDate = localStorage.getItem("modalLastShownDate");

        if (lastShownDate !== today) {
          // Show modal if it hasn't been shown today
          setIsOpenAdd(true);
          localStorage.setItem("modalLastShownDate", today); // Update the last shown date
        } else {
          setIsOpenAdd(false);
        }
      }
    } else {
      // alert("The current date is on or after 16th December 2024!");
      setIsOpenAdd(false);
    }
  }, []);

  useEffect(() => {
    function setBackgroundImage(imageUrl) {
      document.body.style.backgroundImage = "linear-gradient(to bottom, #5d1e6c, #ffec3a)";

      document.body.style.backgroundSize = "cover"; // Ensures the image covers the entire background
      document.body.style.backgroundPosition = "center"; // Centers the image
    }
    // Example usage with a dynamic URL
    // setBackgroundImage(imageUrl);
    setBackgroundImage(`linear-gradient(to bottom,  #5d1e6c,#ffec3a);`)
  }, []);

  useEffect(() => {
    // Update the navigation visibility state
    updateIsNavVisible(true);

    // Function to fetch Free and Paid data based on API type (User/Admin/Anonymous)
    const fetchData = async (freeApiUrl, paidApiUrl) => {
      let value = [];
      value.push(subcategories);
      setFilteredData(value);
    };

    if (username && username.trim()) {
      // If username is available, check user role
      const role = userRole && userRole.trim().toLowerCase(); // Ensure userRole has value and trim spaces

      if (role === "admin" || role === "superadmin") {
        // If user is admin or superadmin, use Admin APIs
        const adminFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Admin/Free?username=${username}`;
        const adminPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Admin/Paid?username=${username}`;

        //fetchData(adminFreeApiUrl, adminPaidApiUrl); // Fetch Admin Free and Paid data
        fetchData(adminPaidApiUrl, adminFreeApiUrl); // Fetch Admin Free and Paid data
      } else {
        // If user is not admin/superadmin, use User APIs
        const userFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/User/Free?username=${username}`;
        const userPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/User/Paid?username=${username}`;

        //fetchData(userFreeApiUrl, userPaidApiUrl); // Fetch User Free and Paid data

        fetchData(userPaidApiUrl, userFreeApiUrl); // Fetch User Free and Paid data
      }
    } else {
      // If no username, use Anonymous APIs
      const anonymousFreeApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Anonymous/Free`;
      const anonymousPaidApiUrl = `https://s3napi.s3nsoftware.com/api/QuizDatas/WordPacksInfo/Anonymous/Paid`;

      // fetchData(anonymousFreeApiUrl, anonymousPaidApiUrl); // Fetch Anonymous Free and Paid data

      fetchData(anonymousPaidApiUrl, anonymousFreeApiUrl); // Fetch Anonymous Free and Paid data
    }
  }, [username, userRole]); // Ensure this effect runs whenever `username` or `userRole` changes

  const [openQuizModel, setOpenQuizModel] = useState(false);
  const [catId, setCatId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [isCollectionId, setIsCollectionId] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [amount, setAmount] = useState(1);
  const [filteredCart, setFilteredCart] = useState([]);
  const updateQuizModel = (value) => {
    setOpenQuizModel(value);
  };

  const [showPaypalModel, setShowPaypalModel] = useState(false); // To manage modal visibility

  const updateShowPaypalModel = (value) => {
    setShowPaypalModel(value);
  };
  // Show the PayPal modal

  useEffect(() => {
    if (cart.length === 0) {
      updateShowCart(false);
    } else {
      // Build a new array with selected fields from the cart
      const filteredCart = cart.map((item) => ({
        packId: item.packId,
        price: item.price,
        isCollection: item.isCollection,
        type: item.type === "monthly" ? true : false,
      }));

      // Do something with the new array, e.g., log it or set it to state
      ////console.log("Filtered Cart:", filteredCart);

      // Optionally, you can save the new array to the state if needed
      setFilteredCart(filteredCart); // Assuming you have a `setFilteredCart` state function
    }
  }, [cart]);

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    ////console.log(" cart data ", savedCart);
    if (savedCart) {
      updateCart(JSON.parse(savedCart)); // Load cart from localStorage
    }
  }, []);

  const [pack, setPack] = useState({});

  const handleClick = (pack) => {
    if (pack.IsLocked) {
      // Show SweetAlert when pack is locked
      Swal.fire({
        icon: "warning",
        text: "Please subscribe for access to the category",
        confirmButtonText: "OK",
      });
    } else {
      // Perform your regular actions when pack is not locked

      navigate(`/playquiz/${pack.Id}`);

      //setCatId(pack.Id);
      //setOpenQuizModel(true);

      //setPack(pack);
      // You can also navigate here if necessary
      // navigate(`/playquiz/${pack.Id}`);
      localStorage.setItem("backgroundimage", pack.CategoryImage);
    }
  };

  // Function to delete an item from the cart
  const deleteItem = (packId, type) => {
    updateCart((prevCart) => {
      // Filter the cart to remove the item
      const updatedCart = prevCart.filter(
        (item) => !(item.packId === packId && item.type === type)
      );

      // Save the updated cart to localStorage
      localStorage.setItem("cart", JSON.stringify(updatedCart));

      // Return the updated cart to update the state
      return updatedCart;
    });
  };

  // Toggle cart visibility
  const toggleCartVisibility = () => {
    //updateCart([]);
    updateShowCart(!showCart);
  };
  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price, 0).toFixed(2);
  };

  const findCategoryName = (pack, id) => {
    // Find the package by Id
    const foundPack = filteredData.find((pac) => pac.Id === pack.CollectionId);

    // Check if the package and its Categories exist
    if (foundPack && foundPack.Categories) {
      // Find the category by Id
      const category = foundPack.Categories.find((cat) => cat.Id === id);

      // Return the CategoryName if found
      return category ? category.CategoryName : "Unknown Category";
    }

    return "Unknown Category"; // Default if package or category not found
  };

  const { updateIsLoginOpen, updateIsSignUpOpen } = usePreference();

  const handleCheckout = () => {
    const loggedin = localStorage.getItem("loggedin");
    if (loggedin == null || loggedin === "false") {
      Swal.fire({
        icon: "warning",
        text: "Please login or signup to subscribe",
        showCancelButton: true, // Show Cancel button
        showDenyButton: true, // Show Deny button
        confirmButtonText: "Login", // Confirm button text
        denyButtonText: "Sign Up", // Deny button text
        cancelButtonText: "Cancel", // Cancel button text
      }).then((result) => {
        if (result.isConfirmed) {
          // "Login" button clicked
          updateIsLoginOpen(true);
          updateIsSignUpOpen(false);
        } else if (result.isDenied) {
          // "Sign Up" button clicked
          updateIsSignUpOpen(true);
          updateIsLoginOpen(false);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // "Cancel" button clicked
          ////console.log("User canceled the action.");
        }
      });

      return;
    }

    // alert("Checkout")
    updateShowPaypalModel(true);
    //setAmount(1);
    setAmount(calculateTotal());
  };

  const scrollToCollection = (index, _) => {
    // Set the search term to the selected package
    setSearchTerm(_.Package);

    // Filter the data to show only the selected package and its categories
    const filtered = data
      .map((packs) => {
        // Check if the package name matches the selected one
        if (packs.Package.toLowerCase() === _.Package.toLowerCase()) {
          return packs; // Return the full package if it matches
        }
        // Otherwise, return null
        return null;
      })
      .filter(Boolean); // Remove null values

    // Set the filtered data to show only the selected package
    setFilteredData(filtered);

    // Optionally scroll to the selected collection (if you want to scroll the page to the filtered section)
  };

  const calculateDaysUntilExpiration = (dateString) => {
    // Parse the date string into a JavaScript Date object
    const expirationDate = new Date(dateString);
    const currentDate = new Date();
    // Calculate the difference in time
    const timeDifference = expirationDate - currentDate;
    // Calculate the difference in days
    const daysUntilExpiration = Math.ceil(
      timeDifference / (1000 * 60 * 60 * 24)
    ); // Convert ms to days
    // Return the number of days, ensure it's not negative
    return daysUntilExpiration > 0 ? daysUntilExpiration : 0;
  };


  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const updateOpenAdd = (value) => {
    setIsOpenAdd(value);
  };

  const scrollContainerRefs = useRef({}); // Object to store refs for each scrollable container

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridColumns = windowWidth <= 480 ? 1 : 8;
  const itemWidth = windowWidth <= 480 ? "100%" : "150px";

  return (
    <>
      {/* <LandingPage /> */}
      {/* <ComingSoon /> */}
      {showCart && (
        <ShowCart
          showCart={showCart}
          toggleCartVisibility={toggleCartVisibility}
          cart={cart}
          deleteItem={deleteItem}
          handleCheckout={handleCheckout}
          calculateTotal={calculateTotal}
          filteredCart={filteredCart}
        />
      )}
      <>
        {" "}
        <div
          id="alldata"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            padding: "20px",
            justifyContent: "center",

          }}
        >
          {Array.isArray(filteredData) ? (
            filteredData.map((packs, index) => (
              <div
                key={packs.Id}
                className="pack-card"
                style={{
                  // opacity:0.8,
                  width:
                    index === 0
                      ? "100%"
                      : window.innerWidth <= 768
                        ? "calc(100% - 20px)"
                        : window.innerWidth <= 1024
                          ? "calc(50% - 20px)"
                          : "calc(33.33% - 20px)", // Responsive widths
                  maxWidth: index === 0 ? "100%" : "350px",
                  display: index === 0 ? "flex" : "block",
                  justifyContent: index === 0 ? "space-around" : "center",
                  boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                  backgroundColor: packs.IsFree
                    ? "#ffff99"
                    : packs.IsFree === false
                      ? "ffff99"
                      : "#fff",
                  borderRadius: "10px",
                  padding: "30px",
                  background: "#fff",
                  border: packs.IsFree
                    ? "5px solid #ffcc00"
                    : packs.IsFree === false
                      ? "5px solid orange"
                      : "transparent",
                  animation:
                    packs.IsFree || packs.IsFree === false
                      ? "blink 1s 0"
                      : "none",
                }}
              >
                {" "}
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px", // Adjust spacing between image and text
                    zIndex: 2000,
                  }}
                > */}
                {/* <img
                    style={{
                      height: "50px",
                      width: "50px",
                    }}
                    src={BEE}
                    alt="placeholder"
                  /> */}
                {/* <h5>
                    {packs.Package}
                  </h5> */}
                {/* </div> */}
                {/* <h6>{packs.description}</h6> */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {index !== 0 && (
                    <p>
                      (
                      {packs.Categories.reduce(
                        (sum, item) => sum + item.WordCount,
                        0
                      )}{" "}
                      words)
                    </p>
                  )}
                  {/* 
                  {packs.IsSubscribed && packs.DiscountDesc === "Subscribed" ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      Subscribed
                    </span>
                  ) : packs.IsFree ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      Always Free
                    </span>
                  ) : (
                    <SubscribeButton
                      packs={packs}
                      addToCart={addToCart}
                      IsCollectionId={true}
                      packname={packs.Package}
                      style={{ padding: "4px 6px", fontSize: "12px" }}
                    />
                  )} */}
                </div>
                {/* Categories inside the pack */}
                {packs.Categories.length >= 0 ? (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      {/* Back Button */}
                      <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "10px" }}>
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "4px 8px",
                            backgroundColor: "#e5e7eb",
                            color: "#374151",
                            borderRadius: "12px",
                            border: "none",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                          }}
                        >
                          <a href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}>
                            <ArrowLeft size={20} />
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Back</span>
                          </a>
                        </button>
                      </div>

                      {/* Categories Horizontal Flex */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {packs.Categories.length > 0 &&
                          packs.Categories.map((pack) => {
                            // Example: assign a unique width per item, you can customize per your logic
                            const itemWidth = pack.Width || "150px"; // default 150px if no custom width

                            return (
                              <div
                                key={pack.Id}
                                style={{
                                  boxShadow: "0px 0px 3px rgba(0,0,0,0.2)",
                                  borderRadius: "8px",
                                  padding: "5px",
                                  backgroundColor: "#f9f9f9",
                                  cursor: "pointer",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: itemWidth, // fixed unique width
                                  flexShrink: 0, // prevent shrinking
                                }}
                                onClick={() => handleClick(pack)}
                              >
                                <div style={{ display: "flex", alignItems: "center", width: "100%", overflow: "hidden" }}>
                                  <img
                                    src={pack.CategoryImage}
                                    alt="Category"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "5px",
                                      flexShrink: 0,
                                      marginRight: "5px",
                                    }}
                                  />
                                  <div
                                    style={{
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "100%",
                                      display: "flex",
                                      gap: "5px",
                                    }}
                                  >
                                    <h6 style={{ fontSize: "10px", margin: 0 }}>{pack.CategoryName}</h6>
                                    <span style={{ fontSize: "10px" }}>({pack.WordCount}W)</span>
                                  </div>
                                </div>

                                <div style={{ marginTop: "5px", display: "flex", justifyContent: "center" }}>
                                  {pack.IsFree ? (
                                    <span style={{ color: "green", fontSize: "10px", display: "block" }}>Always Free</span>
                                  ) : pack.IsLocked ? (
                                    <SubscribeButton
                                      packs={pack}
                                      buttonWidth="50%"
                                      IsCollectionId={false}
                                      addToCart={addToCart}
                                      packname={pack.CategoryName}
                                    />
                                  ) : (
                                    <span style={{ color: "green", fontSize: "10px", display: "block" }}>
                                      Expires in {calculateDaysUntilExpiration(pack.Expired)} days
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    {packs.Categories.length > 4 && (
                      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "5px" }}>
                        <span
                          className="show-more-text"
                          style={{
                            cursor: "pointer",
                            color: "black",
                            textAlign: "right",
                            fontFamily: "sans-serif",
                            fontSize: "12px",
                            fontStyle: "italic",
                            textDecoration: "underline",
                          }}
                        >
                          {/* Info */}
                        </span>
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{ marginTop: "10px" }}>
                    <SubscribeButton
                      packs={packs}
                      buttonWidth="12%"
                      IsCollectionId={true}
                      addToCart={addToCart}
                      packname={packs.Package}
                    />
                  </div>
                )}



              </div>
            ))
          ) : (
            <p>No data found.</p>
          )}
        </div>
      </>

      {openQuizModel ? (
        <QuizzesModel
          open={openQuizModel}
          updateQuizModel={updateQuizModel}
          catId={catId}
          updateQuizId={updateQuizId}
          pack={pack}
        />
      ) : null}

      <PayPalModal
        showPaypalModel={showPaypalModel}
        updateShowPaypalModel={updateShowPaypalModel}
        amount={amount}
        SelectedId={12}
        IsCollectionId={true}
        IsMonthly={true}
        Username={username}
        cartdata={cart}
        filteredCart={filteredCart}
      />

      <AdvertisementModel open={isOpenAdd} updateIsOpen={updateOpenAdd} />
      {/* <footer className="footer">
        <a href="#home" className="to-top-btn">
          <i className="fa fa-arrow-up"></i> To the top
        </a>
        <div className="social-icons">
          <Facebook fontSize="small" />
          <Instagram fontSize="small" />
          <Pinterest fontSize="small" />
          <Twitter fontSize="small" />
          <LinkedIn fontSize="small" />
        </div>
      </footer> */}
    </>
  );
};

export default SubCategories;
